import { __read, __spread } from "tslib";
export function splitWithLimit(str, delim, count) {
    var parts = str.split(delim);
    if (parts.length <= count) {
        return parts;
    }
    return __spread(parts.slice(0, count - 1), [parts.slice(count - 1).join(delim)]);
}
